// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 179) return "3.69.1/styles/main.bundle.css";
	// return url for filenames based on template
	return "3.69.1/styles/" + "videojs" + ".chunk.css?" + "f796e7b1491ccb6b8d83" + "";
};